const INITIAL_STATE = {
  list: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'LOG_ADAPTATIVO_FETCHED':
      return { 
        ...state, 
        list: action.payload.data || [],
        loading: false,
        error: null
      };
    case 'LOG_ADAPTATIVO_LOADING':
      return { 
        ...state, 
        loading: true,
        error: null
      };
    case 'LOG_ADAPTATIVO_ERROR':
      return { 
        ...state, 
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}; 